import type {
  LinkPeriod,
  LinkSubscription,
  OperationLinkOptions,
} from '../../model/operation-link.js';
import type { OperationLinkOptionsDto } from '../dto/operation-link-options.dto.js';

type LinkSubscriptionDto = OperationLinkOptionsDto['subscriptions'][number];

type LinkPeriodDto = LinkSubscriptionDto['periods'][number];

const toLinkPeriod = (dto: LinkPeriodDto): LinkPeriod => ({
  occurrenceId: dto.occurrenceId,
  dueDate: dto.dueDate,
  status: dto.status,
  amountMinor: dto.amountMinor,
  currency: dto.currency,
  bankAmountMinor: dto.bankAmountMinor,
  bankCurrency: dto.bankCurrency,
});

const toLinkSubscription = (dto: LinkSubscriptionDto): LinkSubscription => ({
  paymentId: dto.paymentId,
  name: dto.name,
  periods: dto.periods.map(toLinkPeriod),
  preselectedOccurrenceId: dto.preselectedOccurrenceId,
});

export const toOperationLinkOptions = (dto: OperationLinkOptionsDto): OperationLinkOptions => ({
  subscriptions: dto.subscriptions.map(toLinkSubscription),
});
